import ReactDOM from 'react-dom';

import '@imgly/imgly-website-components/imgly-website-components.css';

export { wrapPageElement, wrapRootElement } from './gatsby-ssr';

// todo: workaround since there where some css issue in components
export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
}
